import React, { useState } from "react";

import { CONTACT_INFO } from "./GymData";

function EnquiryPage({
  onBack,
  darkMode,
  setDarkMode,
}) {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    preferredContact: "WhatsApp",
    message: "",
  });

  const [submitted, setSubmitted] = useState(false);


  // ===============================
  // INPUT CHANGE
  // ===============================

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };


  // ===============================
  // WHATSAPP
  // ===============================

  const sendWhatsApp = () => {

    if (!form.name || !form.phone) {
      alert("Please enter your name and phone number.");
      return;
    }

    const message = `
Hello FITRACK!

I want to make an enquiry.

Name: ${form.name}
Email: ${form.email}
Phone: ${form.phone}
Preferred Contact: ${form.preferredContact}

Message:
${form.message || "I would like to know more about FITRACK."}
`;

    const whatsappURL =
      `https://wa.me/${CONTACT_INFO.whatsapp}` +
      `?text=${encodeURIComponent(message)}`;

    window.open(whatsappURL, "_blank");

    setSubmitted(true);
  };


  // ===============================
  // CALL
  // ===============================

  const callGym = () => {
    window.location.href =
      `tel:${CONTACT_INFO.phone1.replace(/\s/g, "")}`;
  };


  // ===============================
  // FORM SUBMIT
  // ===============================

  const handleSubmit = (e) => {

    e.preventDefault();

    if (!form.name || !form.email || !form.phone) {
      alert("Please fill in Name, Email and Phone Number.");
      return;
    }

    setSubmitted(true);
  };


  return (
    <div className="enquiry-page">

      {/* ================= HEADER ================= */}

      <header className="enquiry-header">

        <button
          className="back-button"
          onClick={onBack}
        >
          ← Back
        </button>


        <div className="logo">
          FIT<span>RACK</span>
        </div>


        <button
          className="theme-toggle"
          onClick={() => setDarkMode(!darkMode)}
        >
          {darkMode
            ? "☀ Day Version"
            : "🌙 Night Version"}
        </button>

      </header>


      {/* ================= MAIN ================= */}

      <main className="enquiry-main">

        <div className="enquiry-left">

          <p className="orange-text">
            GET IN TOUCH
          </p>

          <h1>
            HAVE AN
            <br />
            <span>ENQUIRY?</span>
          </h1>

          <p className="enquiry-description">
            Want to know about membership, gym timings,
            trainers or anything else? Send us a message.
            Our team will get in touch with you.
          </p>


          {/* LOCATION */}

          <div className="contact-box">

            <div className="contact-icon">
              📍
            </div>

            <div>
              <h3>Gym Location</h3>
              <p>{CONTACT_INFO.location}</p>
            </div>

          </div>


          {/* PHONE */}

          <div className="contact-box">

            <div className="contact-icon">
              📞
            </div>

            <div>
              <h3>Call Us</h3>

              <p>{CONTACT_INFO.phone1}</p>
              <p>{CONTACT_INFO.phone2}</p>

            </div>

          </div>


          {/* EMAIL */}

          <div className="contact-box">

            <div className="contact-icon">
              ✉
            </div>

            <div>
              <h3>Email</h3>
              <p>{CONTACT_INFO.email}</p>
            </div>

          </div>


          {/* QUICK BUTTONS */}

          <div className="contact-actions">

            <button
              className="whatsapp-button"
              onClick={() => {
                window.open(
                  `https://wa.me/${CONTACT_INFO.whatsapp}`,
                  "_blank"
                );
              }}
            >
              💬 WhatsApp
            </button>


            <button
              className="call-button"
              onClick={callGym}
            >
              📞 Call Now
            </button>

          </div>

        </div>


        {/* ================= FORM ================= */}

        <div className="enquiry-right">

          <div className="enquiry-form-card">

            <p className="orange-text">
              SEND US A MESSAGE
            </p>

            <h2>
              ENQUIRY FORM
            </h2>


            {submitted && (
              <div className="success-message">
                ✓ Thank you! Your enquiry has been received.
              </div>
            )}


            <form onSubmit={handleSubmit}>

              {/* NAME */}

              <div className="form-group">

                <label>
                  Your Name
                </label>

                <input
                  type="text"
                  name="name"
                  placeholder="Enter your name"
                  value={form.name}
                  onChange={handleChange}
                />

              </div>


              {/* EMAIL */}

              <div className="form-group">

                <label>
                  Email Address
                </label>

                <input
                  type="email"
                  name="email"
                  placeholder="Enter your email"
                  value={form.email}
                  onChange={handleChange}
                />

              </div>


              {/* PHONE */}

              <div className="form-group">

                <label>
                  Phone Number
                </label>

                <input
                  type="tel"
                  name="phone"
                  placeholder="Enter your phone number"
                  value={form.phone}
                  onChange={handleChange}
                />

              </div>


              {/* CONTACT METHOD */}

              <div className="form-group">

                <label>
                  How should we contact you?
                </label>

                <select
                  name="preferredContact"
                  value={form.preferredContact}
                  onChange={handleChange}
                >
                  <option value="WhatsApp">
                    WhatsApp
                  </option>

                  <option value="Call">
                    Phone Call
                  </option>

                  <option value="Email">
                    Email
                  </option>
                </select>

              </div>


              {/* MESSAGE */}

              <div className="form-group">

                <label>
                  Your Message
                </label>

                <textarea
                  name="message"
                  rows="5"
                  placeholder="Write your enquiry..."
                  value={form.message}
                  onChange={handleChange}
                />

              </div>


              {/* SUBMIT */}

              <button
                type="submit"
                className="enquire-glow-button full-button"
              >
                SUBMIT ENQUIRY →
              </button>


              {/* WHATSAPP */}

              <button
                type="button"
                className="whatsapp-form-button"
                onClick={sendWhatsApp}
              >
                💬 SEND DIRECTLY ON WHATSAPP
              </button>

            </form>

          </div>

        </div>

      </main>

    </div>
  );
}

export default EnquiryPage;